import { Receipt as ReceiptIcon } from "lucide-react";
import type { Receipt, Category } from "../../types";
import { ReceiptItem } from "./ReceiptItem";

interface Props {
  receipts: Receipt[];
  categories: Category[];
  loading: boolean;
  onSelect: (receipt: Receipt) => void;
}

export function ReceiptList({ receipts, categories, loading, onSelect }: Props) {
  if (loading) {
    return <div style={{ color: "#64748b", padding: "3rem", textAlign: "center" }}>Loading receipts…</div>;
  }
  if (receipts.length === 0) {
    return (
      <div style={{ color: "#64748b", padding: "3rem", textAlign: "center" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "0.75rem" }}><ReceiptIcon size={40} strokeWidth={1.5} /></div>
        <div>No receipts yet. Upload your first one!</div>
      </div>
    );
  }
  return (
    <div>
      {receipts.map(r => (
        <ReceiptItem key={r.id} receipt={r} categories={categories} onClick={() => onSelect(r)} />
      ))}
    </div>
  );
}
